import { useMemo } from "react";

import {
  RadioEmptyDisabled,
  RadioEmptyEnabled,
  RadioFullDisabled,
  RadioFullEnabled,
  CheckboxEmptyDisabled,
  CheckboxEmptyEnabled,
  CheckboxFullDisabled,
  CheckboxFullEnabled,
} from "src/assets";

export const useInputGroup = ({ style }: { style: "radio" | "checkbox" }) => {
  const imagesSource = useMemo(() => {
    if (style === "radio" || !style)
      return {
        "full-disabled": RadioFullDisabled,
        "full-enabled": RadioFullEnabled,
        "empty-disabled": RadioEmptyDisabled,
        "empty-enabled": RadioEmptyEnabled,
      };

    return {
      "full-disabled": CheckboxFullDisabled,
      "full-enabled": CheckboxFullEnabled,
      "empty-disabled": CheckboxEmptyDisabled,
      "empty-enabled": CheckboxEmptyEnabled,
    };
  }, [style]);

  return { imagesSource };
};
